import type { ConceptContentData } from "../types";
import { ConceptCodeBlock, ConceptDefinition, ConceptText } from "./components";

type RuleAnatomyContent = Extract<ConceptContentData, { slug: "rule-anatomy" }>;

export function RuleAnatomyConcept({
  content,
}: {
  content: RuleAnatomyContent;
}) {
  return (
    <div className="grid gap-7">
      <div className="grid items-start gap-6 lg:grid-cols-[minmax(0,1.05fr)_minmax(20rem,0.95fr)]">
        <ConceptCodeBlock
          caption={content.exampleCaption}
          lines={content.exampleLines}
        />

        <dl className="divide-border border-border divide-y border-y">
          {content.definitions.map((definition) => (
            <ConceptDefinition
              key={definition.id}
              id={definition.id}
              term={definition.term}
            >
              <ConceptText text={definition.body} />
            </ConceptDefinition>
          ))}
        </dl>
      </div>

      <p className="text-muted-foreground max-w-3xl leading-7">
        <ConceptText text={content.conclusion} />
      </p>
    </div>
  );
}
